import type { State } from "../State";

/** Takes an immutable export snapshot while expanded, then restores the model before rendering. */
export function withTerminalBlocksForExport<T>(app: State, showUnusedWires: boolean, collect: () => T): T {
  if (!showUnusedWires) return collect();
  const undo = app.undoManager;
  if (undo.undoStepIsOpen || undo.isCompletingInteraction || undo.disableAddStep ||
      app.suppressUndoObservation || app.isLoadingFromEstadaStorage)
    throw new Error("Bitte die aktuelle Bearbeitung abschließen, bevor der Klemmenplan erstellt wird.");
  const strips = app.cabinets.asArray().filter(cabinet => !cabinet.isDeleted)
    .flatMap(cabinet => cabinet.terminalStrips.asArray().filter(strip => !strip.isDeleted));
  return undo.runAsSingleStep("Klemmen für PDF vorübergehend aufteilen", () => {
    try {
      for (const strip of strips) for (const block of strip.getTerminalBlocks())
        block.splitGroupTerminalIntoSingleTerminals();
      return collect();
    } finally {
      undo.rollbackCurrentStep();
      for (const strip of strips) strip.calcListInfos();
    }
  });
}
